import React, { useContext, useEffect } from "react";
import moment from "moment";
import { ProyectosContext } from "../../context/ProyectosContext";
import { quitarClaveNombre } from "../../utils/destajos";
import TextoExpandible from "../common/TextoExpandible";
import { soloComentario } from "../../utils";

const ATRIBUTOS = {
  nombre: "Nombre",
  orden: "Orden",
  ponderacion: "Ponderación",
  FechaInicio: "Fecha inicio",
  FechaFin: "Fecha fin",
  puntoCritico: "Punto crítico",
  notificar: "Notificar",
  dependencias: "Dependencias",
  idPartida: "Partida",
};

// Attributes that only repeat what the action already says.
const OCULTOS = ["deletedAt", "idProyecto", "createdAt", "updatedAt"];

const ACCIONES = {
  crear: { label: "Creó", color: "success", icono: "fa-plus" },
  actualizar: { label: "Actualizó", color: "primary", icono: "fa-pen" },
  eliminar: { label: "Eliminó", color: "danger", icono: "fa-trash" },
  restaurar: { label: "Restauró", color: "warning", icono: "fa-undo" },
};

const formatValor = (key, value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Sí" : "No";
  if (Array.isArray(value)) return value.length ? value.join(", ") : "—";
  if (key === "FechaInicio" || key === "FechaFin") {
    const fecha = moment(value);
    return fecha.isValid() ? fecha.format("DD MMM YYYY") : String(value);
  }
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

const tituloDia = (value) => {
  const fecha = moment(value);
  const dias = moment().startOf("day").diff(moment(fecha).startOf("day"), "days");
  if (dias === 0) return "Hoy";
  if (dias === 1) return "Ayer";
  return fecha.format("DD MMM YYYY");
};

const HistorialObra = ({ idProyecto }) => {
  const { historial, historialHasMore, getHistorialProyecto } =
    useContext(ProyectosContext);

  useEffect(() => {
    getHistorialProyecto(idProyecto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Only updates list their attributes; for the other actions the badge and
  // the comment already tell what happened.
  const renderCambios = ({ accion, estado_anterior, estado_nuevo }) => {
    if (accion !== "actualizar") return null;
    const anterior = estado_anterior || {};
    const nuevo = estado_nuevo || {};
    const keys = Object.keys({ ...anterior, ...nuevo }).filter(
      (key) => !OCULTOS.includes(key)
    );
    if (keys.length === 0) return null;
    return (
      <div className="d-flex flex-wrap gap-2 mt-2">
        {keys.map((key) => (
          <div
            key={key}
            className="small rounded-pill border bg-light px-3 py-1"
            style={{ maxWidth: "100%" }}
          >
            <span className="text-muted me-2">{ATRIBUTOS[key] || key}</span>
            <span className="text-muted text-decoration-line-through">
              {formatValor(key, anterior[key])}
            </span>
            <i className="fa fa-arrow-right mx-2 text-muted small" />
            <span className="bold">{formatValor(key, nuevo[key])}</span>
          </div>
        ))}
      </div>
    );
  };

  const renderCard = (cambio) => {
    const accion = ACCIONES[cambio.accion] || {
      label: cambio.accion,
      color: "secondary",
      icono: "fa-circle",
    };
    const nombre = quitarClaveNombre(cambio.nombre_entidad, cambio.clave);
    const comentario = soloComentario(cambio.comentario);
    return (
      <div
        key={`historial-${cambio.idHistorialCambio}`}
        className="card border shadow-sm mb-3"
        style={{ borderRadius: 10 }}
      >
        <div className="card-body p-3">
          <div className="small mb-1">
            <i className={`fa ${accion.icono} text-${accion.color} me-2`} />
            <span className={`text-${accion.color} bold`}>{accion.label}</span>
            <span className="text-muted"> {cambio.entidad?.toLowerCase()}</span>
          </div>
          <TextoExpandible>
            {cambio.clave && (
              <span className="text-muted me-1">[{cambio.clave}]</span>
            )}
            <span className="bold">{nombre || `#${cambio.idEntidad}`}</span>
          </TextoExpandible>
          {cambio.nombre_partida && (
            <div className="small text-muted">
              <i className="fa fa-folder me-1" />
              {cambio.nombre_partida}
            </div>
          )}
          {renderCambios(cambio)}
          {comentario && (
            <div
              className="small mt-2 p-2 rounded bg-light"
              style={{ borderLeft: "3px solid var(--primary)" }}
            >
              <i className="fa fa-comment text-muted me-1" />
              {comentario}
            </div>
          )}
          <div className="small text-muted mt-2">
            <i className="fa fa-clock me-1" />
            {moment(cambio.createdAt).format("HH:mm")}
            {(cambio.nombre_usuario || cambio.correo_usuario) && (
              <> · {cambio.nombre_usuario || cambio.correo_usuario}</>
            )}
          </div>
        </div>
      </div>
    );
  };

  if (!Array.isArray(historial)) return <div className="spinner-border" />;
  if (historial.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        <i className="fa fa-history fa-2x mb-2 d-block" />
        Aún no hay cambios registrados.
      </div>
    );
  }

  let diaActual = null;
  return (
    <div>
      {historial.map((cambio) => {
        const dia = moment(cambio.createdAt).format("YYYY-MM-DD");
        const header =
          dia !== diaActual ? (
            <div className="small bold text-muted text-uppercase mt-2 mb-2">
              {tituloDia(cambio.createdAt)}
            </div>
          ) : null;
        diaActual = dia;
        return (
          <React.Fragment key={`dia-${cambio.idHistorialCambio}`}>
            {header}
            {renderCard(cambio)}
          </React.Fragment>
        );
      })}
      {historialHasMore && (
        <button
          className="btn btn-sm btn-outline-primary w-100 mb-3"
          onClick={() => getHistorialProyecto(idProyecto, historial.length)}
        >
          Cargar más
        </button>
      )}
    </div>
  );
};

export default HistorialObra;
